import { NameDto } from '../../Common/Types'
import { CurrencyType } from './Wallet'

export enum WalletPaymentProviderOptionType {
  AllowToProcessAutomaticWithdrawValidations = 3050,
  AllowToAutomaticallyCompleteWithdrawTxAfterSucceededValidations = 3070,
  ValidationCheckForMaximumAmount = 3100,
  ValidationCheckForWithdrawalFrequency = 3200,
  ValidationCheckForAnyActiveTransactionOrPaymentNotes = 3300,
  ValidationCheckForDepositWithdrawalAmountRatio = 3400,
  ValidationCheckForClientUncoveredCardDeposits = 3500,
  ValidationCheckForPaymentAmountsTiers = 3600,
}
export interface PspWdCheckPaymentOptionsDto {
  paymentProvider: NameDto<string>
  walletTypeOptions: PspWdCheckWalletTypeOptions[]
}

export interface PspWdCheckWalletTypeOptions {
  walletType: NameDto
  countryIds: string[] | null
  checkState: NameDto
  pspOptions: PspOptionDto[]
}

export interface PspOptionDto {
  paymentOption: NameDto
  selected: boolean
  options?: PspOptions
}

export interface PspOptions {
  DefaultMaxAmount: number
  MaxAmounts: { CurrencyId: CurrencyType; Amount: number }[]
  maxAmount?: {
    EUR: number
    GBP: number
    USD: number
    PLN: number
    ZAR: number
    Default: number
  }
  AllowedCount?: number
  MinAllowedCount?: number
  MaxAllowedCount?: number
}

interface PspGroupMethodDto {
  group: NameDto<string>
  paymentProvider: NameDto<string>
  methodType: NameDto
}

interface PspGroupDto {
  id: string
  name: string | null
  pspGroupType: NameDto
  methods: PspGroupMethodDto[]
  dateCreated: string
  dateUpdated: string
}
export interface WalletFullPaymentProviderDto {
  id: string
  name: string | null
  processor: NameDto<string>
  depositAutomationType: NameDto
  withdrawAutomationType: NameDto
  service: NameDto
  options: WalletPaymentProviderOptionDto[]
  groups: PspGroupDto[]
}

export interface WalletPaymentProviderOptionDto {
  id: string
  paymentProvider: NameDto<string>
  paymentOption: WalletPaymentOptionDto
  country: NameDto<string>
  options: {}
}

export interface WalletPaymentOptionDto {
  id: number
  name: string | null
  type: NameDto
}

export enum WalletPaymentProviderKey {
  name = 'name',
}

export enum WalletPaymentProviderFilterKey {
  name = 'Name',
  CheckStateFx = 'CheckStateFx',
  CheckStateIb = 'CheckStateIb',
}

export const CheckStates = [
  { id: 0, name: 'None' },
  { id: 10, name: 'Automated' },
  { id: 20, name: 'Bulk' },
]
